import * as React from "react"
import { FooterStyles } from "./FooterStyles"
import Socials from "../Socials/Socials";

const Footer = () => {
  return (
    <FooterStyles style={{ marginBottom: 0 }} className="section">
      <div className="container container__tight">
        <small>All content copyright A Vulgar Display Of Flour</small>
        <Socials />
      </div>
    </FooterStyles>
  )
}

export default Footer
